export default __webpack_public_path__ + "static/media/bg.6d6973c6.png";